import { createStore } from '@/zustand/storeCreator';
import Cookies from 'js-cookie';

interface Image {
  url: string;
  alt: string | null;
  __typename: 'Image';
}

export interface AddressI {
  id: string;
  name: string;
  city?: string;
  streetAddress: string;
  houseNumber: string;
  apartmentNumber: string;
  houseSection: string;
  doorCode: string;
  note: string;
  isDefaultShippingAddress: boolean;
  isDefaultBillingAddress: boolean;
  floor?: string;
}

export interface User {
  id: string;
  email: string;
  cityName: string;
  phone: string;
  firstName: string;
  lastName: string;
  isStaff: boolean;
  isActive: boolean;
  isConfirmed: boolean;
  avatar: Image;
  addresses: AddressI[];
  bonusesQr: string;
  bonusesAmount: number;
  bonusesBarcode: string;
  __typename: 'User';
}

interface AuthStoreState {
  user: User | null;
  setUser: (userData: User) => void;
  clearUser: () => void;
  deleteAddress: (addressId: string) => void;
  addAddress: (address: AddressI) => void;
  updateAddress: (addressId: string, updatedAddress: AddressI) => void;
}

const useUserStore = createStore<AuthStoreState>(
  set => ({
    user: null,
    setUser: userData => set({ user: userData }),
    clearUser: () => {
      set({ user: null });
      Cookies.remove('accessToken');
      Cookies.remove('refreshToken');
      Cookies.remove('authToken');
    },
    addAddress: address =>
      set(
        state =>
          ({
            user: {
              ...state.user,
              addresses: [...(state.user?.addresses ?? []), address],
            },
          }) as AuthStoreState
      ),
    deleteAddress: (addressId: string) =>
      set(
        state =>
          ({
            user: {
              ...state.user,
              addresses: state.user?.addresses.filter(
                address => address.id !== addressId
              ),
            },
          }) as AuthStoreState
      ),
    updateAddress: (addressId: string, updatedAddress: AddressI) =>
      set(
        state =>
          ({
            user: {
              ...state.user,
              addresses: state.user?.addresses.map(address =>
                address.id === addressId ? updatedAddress : address
              ),
            },
          }) as AuthStoreState
      ),
  }),
  { name: 'user-storage' }
);

export default useUserStore;
